module.exports = __webpack_public_path__ + "static/media/sample_product.d6a8edec.png";